import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Component, OnInit, PipeTransform, ViewChild } from '@angular/core';
import { SharedService } from '../shared.service';
import { CalculateLeavesComponent } from './calculate-leaves/calculate-leaves.component';
import swal from 'sweetalert';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { config } from 'rxjs';
import { AppConfigService } from '../app-config.service';
@Component({
  selector: 'app-attendance-summary',
  templateUrl: './attendance-summary.component.html',
  styleUrls: ['./attendance-summary.component.scss'],
  providers: [NgbProgressbarConfig]
})
export class AttendanceSummaryComponent implements OnInit {
  @ViewChild(CalculateLeavesComponent)
  private calcLeaves!: CalculateLeavesComponent;
  contactList = [] as any;
  resultArray = [] as any;
  resultArray2 = [] as any;
  monthList: any = [];
  employeeList: any = [];
  attendanceList: any = [];
  leaveList: any = [];
  attendance: any;
  clockifyList: any = [];
  ModalTitle: any;
  activateAddEditAttendance: boolean = false;
  Date: any;
  employee: any;
  @ViewChild('fileInput') fileInput: any;
  public isCollapsed = false;
  month: any = 'January';
  monthDropdown =
    [
      { Value: 1, Text: 'January' },
      { Value: 2, Text: 'February' },
      { Value: 3, Text: 'March' },
      { Value: 4, Text: 'April' },
      { Value: 5, Text: 'May' },
      { Value: 6, Text: 'June' },
      { Value: 7, Text: 'July' },
      { Value: 8, Text: 'August' },
      { Value: 9, Text: 'September' },
      { Value: 10, Text: 'October' },
      { Value: 11, Text: 'November' },
      { Value: 12, Text: 'December' }
    ]
  monthNum: any = new Date().getMonth() + 1;
  year: any = new Date().getFullYear();
  yearDropdown: number[] = [];
  dateLastImported: any;
  dateLastImportedFor: any;
  progressBarValue: number = 0;
  showProgressBar: boolean = false;
  settingId = 3;
  fileName: string = "Choose File";
  constructor(private service: SharedService, private bar: NgbProgressbarConfig, private appSettings: AppConfigService) {
    bar.animated = true;
    bar.striped = true;
    bar.type = 'info';
    bar.height = '10px';
    bar.showValue = true;
  }
  ngOnInit(): void {
    var currentYear = new Date().getFullYear();
    this.yearDropdown = [];
    for (let yearItem = this.appSettings.getStartYear(); yearItem <= currentYear; yearItem++) {
      this.yearDropdown.push(yearItem);
    }
    this.GetMonthName(this.monthNum);
    this.RefreshEmpList();
    this.RefreshAttendanceList();
    this.RefreshMonthList(this.monthNum, this.year);
    this.RefreshLeaveList(this.monthNum, this.year);
    this.RefreshClockifyList(this.monthNum, this.year);
    this.GetClockifyAllUsers();
    this.GetLastImportDate(this.settingId);
  }
  Test() {
    this.service.GetSetting(this.settingId).subscribe(data => {
      console.log(data[0].LastImportDate)
    });
  }
  GetLastImportDate(settingId: number) {
    this.service.GetSetting(settingId).subscribe(data => {
      this.dateLastImported = data[0].LastImportDate,
        this.dateLastImportedFor = data[0].LastImportFor
    });
  }
  SetLastImportDate(settingId: number, monthNum: number, year: number) {
    this.service.UpdateLastImportDate(settingId, monthNum, year).subscribe(data => {
      //this.dateLastImported = data
    });
  }
  RefreshClockifyList(month: number, year: number) {
    this.service.GetClockifyData(month, year).subscribe(data => {
      this.clockifyList = data
    });
  }
  RefreshEmpList() {
    this.service.GetEmpList().subscribe(data => {
      this.employeeList = data
    });
  }
  RefreshAttendanceList() {
    this.service.GetAttendanceList()
      .toPromise()
      .then(data => {
        this.attendanceList = data;
      });
  }
  RefreshLeaveList(month: number, year: number) {
    this.service.GetMonthlyLeaves(month, year).subscribe(data => {
      this.leaveList = data;
    });
  }
  Click(Date: any, Emp: any) {
    //console.log(this.Date);
    this.attendance =
    {
      fkEmpId: 0
    }
    this.Date = Date;
    this.employee = Emp;
    this.ModalTitle = "Edit This Attendance";
    this.activateAddEditAttendance = true;
  }
  CloseClick() {
    this.activateAddEditAttendance = false;
    this.RefreshAttendanceList();
    this.RefreshMonthList(this.monthNum, this.year);
    this.RefreshEmpList();
    this.RefreshLeaveList(this.monthNum, this.year);
    this.RefreshClockifyList(this.monthNum, this.year);
  }
  RefreshMonthList(month: number, year: number) {
    this.service.GetCurrentMonth(month, year).subscribe(data => {
      this.monthList = data;
    });
  }
  CheckBusinessDay(date: any) {
    var temp: any;
    this.service.GetDayDetails(date).subscribe(data => {
      temp = data;
    });
  }
  CheckAttendance(date: any, emp: number) {
    for (let i = 0; i < this.attendanceList.length; i++) {
      if (this.attendanceList[i]['Date'] == date) {
        if (this.attendanceList[i]['fkEmpId'] == emp) {
          return true
        }
      }
    }
    return false
  }
  CheckWeekend(date: any) {
    for (let i = 0; i < this.monthList.length; i++) {
      if (this.monthList[i]['pkDate'] == date) {
        if (this.monthList[i]['IsWeekday'] == false) {
          return true
        }
      }
    }
    return false
  }
  CheckWorkHours(date: any, emp: number) {
    for (var attendance of this.attendanceList) {
      if (attendance.Date == date && attendance.fkEmpId == emp) {
        if (attendance.WorkHours == 'Full') {
          return 1
        }
        else if (attendance.WorkHours == "Half") {
          return 5
        }
        else if (attendance.WorkHours == "Quarter") {
          return 6
        }
        else {
          return 0
        }
      }
    }
    return 0
  }
  CheckMarkedLeave(date: any, emp: number) {
    for (var leave of this.leaveList) {
      if (leave.Date == date && leave.fkEmpId == emp) {
        if (leave.Type == '') {
          return 2
        }
        else {
          return 20
        }
      }
    }
    return 2
  }
  CheckClockifyHours(date: any, emp: number, clockifyId: any) {
    for (var clockify of this.clockifyList) {
      if (clockify.Date == date && clockify.ClockifyId == clockifyId) {
        if (clockify.WorkHours == 'Full') {
          return 1
        }
        else if (clockify.WorkHours == 'Half') {
          //half day
          return 7
        }
        else if (clockify.WorkHours == 'Quarter') {
          //quarter day
          return 8
        }
        else {
          return this.CheckMarkedLeave(date, emp)
        }
      }
    }
    return this.CheckMarkedLeave(date, emp)
  }
  IsEmployeeTechnical(empId: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == empId) {
        if (employee.ClockifyId != '') {
          return true
        }
        else {
          return false
        }
      }
    }
    return false
  }
  CheckClockifyPresence(date: any, clockifyId: any) {
    for (var clockify of this.clockifyList) {
      if (clockify.Date == date && clockify.ClockifyId == clockifyId) {
        return true
      }
    }
    return false
  }
  IsPublicHoliday(date: any) {
    let temp = this.monthList.find((i: { pkDate: any; }) => i.pkDate === date);
    if (temp.IsHoliday) {
      return true
    }
    else {
      return false
    }
  }
  CheckDayAndEmployee(date: any, emp: number, clockifyId: any) {
    if (this.IsEmployeeTechnical(emp)) {
      if (this.CheckWeekend(date)) {
        if (this.CheckClockifyPresence(date, clockifyId)) {
          if (this.CheckClockifyHours(date, emp, clockifyId) == 2) {
            return 3
          }
          else {
            return this.CheckClockifyHours(date, emp, clockifyId)
          }
        }
        else {
          return 3
        }
      }
      else if (this.IsPublicHoliday(date)) {
        if (this.CheckClockifyPresence(date, clockifyId)) {
          if (this.CheckClockifyHours(date, emp, clockifyId) == 2) {
            return 30
          }
          else {
            return this.CheckClockifyHours(date, emp, clockifyId)
          }
        }
        else {
          return 30
        }
      }
      else {
        return this.CheckClockifyHours(date, emp, clockifyId)
      }
    }
    else {
      if (this.CheckWeekend(date)) {
        if (this.CheckAttendance(date, emp)) {
          //weekend - worked
          return 4
        }
        else {
          //weekend
          return 3
        }
      }
      else if (this.IsPublicHoliday(date)) {
        if (this.CheckAttendance(date, emp)) {
          return 4
        }
        else {
          return 30
        }
      }
      else {
        if (this.CheckAttendance(date, emp)) {
          // worked
          return this.CheckWorkHours(date, emp);
        }
        else {
          //absent
          return this.CheckMarkedLeave(date, emp)
        }
      }
    }
  }
  UpdateMonth(month: number, MonthName: string) {
    this.month = MonthName;
    this.monthNum = month;
    this.ngOnInit();
  }
  UpdateYear(year: number) {
    this.year = year;
    this.RefreshMonthList(this.monthNum, this.year);
    this.ngOnInit();
  }
  GetMonthName(monthNum: number) {
    var temp = this.monthDropdown.find(i => i.Value === monthNum);
    this.month = temp?.Text;
  }
  async UploadFile() {
    swal
      ({
        title: "Are you sure?",
        text: "All data for this month will be deleted and re-entered. Please make sure to not interrupt the process.",
        icon: "warning",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then(async (confirm) => {
        if (confirm) {
          var today = new Date();
          var startDate = new Date(`${this.year}-${this.monthNum}-01`).toISOString();
          if ((today.getMonth() + 1) == this.monthNum) {
            var date = today.getDate();
            var endDate = new Date(`${this.year}-${this.monthNum}-${date}`).toISOString();
          }
          else {
            var endDate = new Date(this.year, this.monthNum, 1).toISOString();
          }
          let file = new FormData();
          file.append('file', this.fileInput.nativeElement.files[0]);
          this.service.UploadExcel(file).subscribe(data => {
            if (data.toString() === "Excel Sheet is processed") {
              swal
                ({
                  title: "Success",
                  text: data.toString(),
                  icon: "success",
                  buttons:
                  {
                    confirm: true,
                  },
                })
            }
            else {
              swal
                ({
                  title: "Missing Excel File",
                  text: data.toString(),
                  icon: "info",
                  buttons:
                  {
                    confirm: true,
                  },
                  dangerMode: true,
                })
            }
          });
          this.service.DeleteTaskMonth(this.monthNum, this.year).subscribe(data => {
            console.log(data)
          });
          this.service.DeleteClockifyMonth(this.monthNum, this.year).subscribe(data => {
            console.log(data)
          });
          this.service.DeleteEmployeeLeaveForMonth(this.monthNum, this.year).subscribe(data => {
            console.log(data)
          });
          this.service.DeleteCompensationForMonth(this.monthNum, this.year).subscribe(data => {
            console.log(data)
          });
          this.showProgressBar = true;
          for (let i = 0; i < this.resultArray2.length; i++) {
            await new Promise(resolve => this.service.
              GetClockifyContacts(this.resultArray2[i]['UserId'], startDate, endDate).subscribe(data => {
                console.log(data);
                this.contactList = data;   //contact list contains 20 keys wanted to retain only 6 keys
                resolve(data)
                for (let i = 0; i < this.contactList.length; i++) {
                  let task =
                  {
                    pkTaskId: this.contactList[i]['id'],
                    Project: this.contactList[i]['projectId'],
                    ClockifyId: this.contactList[i]['userId'],
                    Description: this.contactList[i]['description'],
                    StartTime: this.contactList[i]['timeInterval']['start'],
                    EndTime: this.contactList[i]['timeInterval']['end'],
                    Date: this.contactList[i]['timeInterval']['start'],
                    Duration: this.contactList[i]['timeInterval']['duration']
                  }
                  this.resultArray.push(task);
                }
              }));
          }
          this.PostClockify();
          this.RefreshAttendanceList();
          this.RefreshMonthList(this.monthNum, this.year);
          this.RefreshLeaveList(this.monthNum, this.year);
          this.RefreshClockifyList(this.monthNum, this.year);
        }
      });
  }
  async PostClockify() {
    var increment = 100 / this.resultArray.length;
    for (let i = 0; i < this.resultArray.length; i++) {
      this.progressBarValue = this.progressBarValue + increment;
      await new Promise(resolve => this.service.PostClockifyContacts(this.resultArray[i]).
        subscribe(data => {
          resolve(data)
          console.log("Data Saved Successfully");
        },
          error => {
            console.log(error)
            console.log("Data Not Saved Suceesfully");
            this.showProgressBar = false;
            this.progressBarValue = 0;
          }));
    }
    this.FilterClockify()
  }
  async FilterClockify() {
    await new Promise(resolve => this.service.PostClockifyFilter().subscribe(data => {
      swal
        ({
          title: "Success",
          text: "Data imported successfully. Please Refresh the page once!",
          icon: "success",
          buttons:
          {
            confirm: true,
          },
        })
      resolve(data)
      this.SetLastImportDate(this.settingId, this.monthNum, this.year);
      this.showProgressBar = false;
      this.calcLeaves.CalculateLeaves(this.employeeList);
    },
      error => {
        swal("ERROR", error, "error");
        this.showProgressBar = false;
        this.progressBarValue = 0;
      }));
  }
  GetClockifyAllUsers() {
    this.service.GetClockifyAllUsers().subscribe(data => {
      this.contactList = data;   //contact list contains 20 keys wanted to retain only 6 keys
      for (let i = 0; i < this.contactList.length; i++) {
        let Users =
        {
          UserId: this.contactList[i]['id'],
        }
        this.resultArray2.push(Users);
      }
    });
  }
  updateFileName(fileInput: any) {
    this.fileName = fileInput.target.files[0].name;
  }
}